module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "name": "set-conference-url-modal",
      "height": "auto",
      "pivot-y": 0.3,
      "adaptive": true,
      "width": 428
    },
    on: {
      "before-open": _vm.beforeOpen
    }
  }, [_c('div', {
    staticClass: "SetConferenceUrl__container"
  }, [_c('div', {
    staticClass: "SetConferenceUrl__title"
  }, [_vm._v("\n      Change Conference URL\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "SetConferenceUrl__description"
  }, [_vm._v("\n      Please complete the URL by entering the ID. kingsconference.ng/\n    ")]), _vm._v(" "), _c('form', {
    attrs: {
      "name": "settings"
    }
  }, [_c('div', {
    staticClass: "Grid-row"
  }, [_c('div', {
    staticClass: "form-label uppercase"
  }, [_vm._v("\n          URL\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "field",
    class: {
      'is-danger': _vm.errors.has('username')
    },
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": "Enter Conference URL",
      "data-vv-delay": "500",
      "data-vv-as": "URL",
      "data-vv-name": "username",
      "required": ""
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Grid-row"
  }, [_c('div', {
    staticClass: "form-actions pull-right"
  }, [_c('a', {
    staticClass: "cancel-btn",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("cancel")]), _vm._v(" "), _c('a', {
    staticClass: "submit-btn",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("save")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fc6c7c1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main-menu/settings-tab/set-conference-url.modal/set-conference-url.modal.vue
// module id = 442
// module chunks = 1